module.exports = __webpack_public_path__ + "media/images/vendor_intro_slide_img_02-bcf52bf0e9ad8fa1cfa80a05eebf94f5.jpg";